import styled from "styled-components";

export const ContactContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 2.5rem 0 3rem;
  background:
    radial-gradient(
      ellipse 65% 45% at 10% 5%,
      rgba(127, 90, 240, 0.16),
      transparent 48%
    ),
    radial-gradient(
      ellipse 50% 35% at 92% 12%,
      rgba(255, 152, 64, 0.14),
      transparent 45%
    ),
    #04050b;

  .contact-shell {
    flex: 1;
    width: 100%;
  }

  .glass-card {
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 18px;
    background: linear-gradient(
        145deg,
        rgba(255, 255, 255, 0.06),
        rgba(255, 255, 255, 0.02)
      ),
      rgba(7, 10, 22, 0.62);
    backdrop-filter: blur(10px);
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.32);
  }

  .contact-intro {
    padding: 1.45rem 1.25rem;

    @media (min-width: 768px) {
      padding: 1.8rem 1.65rem;
    }
  }

  .eyebrow {
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    font-size: 11px;
    font-weight: 700;
    color: rgba(179, 213, 255, 0.65);
  }

  .intro-copy {
    color: rgba(228, 236, 250, 0.88) !important;
    line-height: 1.75;
    font-size: 15px;
  }

  .contact-cards {
    margin-top: 0.75rem;
  }

  .contact-card {
    display: flex;
    gap: 0.8rem;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 0.85rem;
    background: rgba(255, 255, 255, 0.035);

    h4 {
      color: #ffffff;
      margin: 0 0 4px;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      margin: 0;
      color: rgba(202, 216, 236, 0.8) !important;
      font-size: 13px;
      line-height: 1.45;
    }
  }

  .icon-shell {
    width: 58px;
    height: 58px;
    flex-shrink: 0;
    border-radius: 12px;
    border: 1px solid rgba(127, 90, 240, 0.35);
    background: rgba(127, 90, 240, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contact-form-wrap {
    padding: 1.45rem 1.25rem;

    @media (min-width: 768px) {
      padding: 1.9rem 1.75rem;
    }
  }

  .form-title {
    margin: 0;
    color: #f8fbff;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  .form-label {
    color: rgba(218, 228, 242, 0.95);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  .form-control {
    border: 1px solid rgba(255, 255, 255, 0.11);
    background-color: rgba(255, 255, 255, 0.03);
    color: #f6f8ff;
    border-radius: 12px;
    padding: 0.72rem 0.9rem;
    font-size: 14px;
    box-shadow: none !important;

    &:focus {
      border-color: rgba(127, 90, 240, 0.6);
      background-color: rgba(255, 255, 255, 0.045);
      color: #ffffff;
      box-shadow: 0 0 0 0.2rem rgba(127, 90, 240, 0.14) !important;
    }
  }

  textarea.form-control {
    min-height: 140px;
    resize: vertical;
  }

  input::placeholder,
  textarea::placeholder {
    color: rgba(206, 217, 235, 0.45);
  }

  .contact-submit {
    border-radius: 999px !important;
    border: 1px solid rgba(127, 90, 240, 0.65) !important;
    background: linear-gradient(
      95deg,
      rgba(127, 90, 240, 0.86),
      rgba(13, 194, 254, 0.68)
    ) !important;
    color: #ffffff !important;
    padding: 0.56rem 1.35rem !important;
    font-weight: 600;
    letter-spacing: 0.02em;

    &:hover,
    &:focus,
    &:active {
      background: linear-gradient(
        95deg,
        rgba(111, 72, 232, 0.95),
        rgba(13, 194, 254, 0.82)
      ) !important;
      border-color: rgba(13, 194, 254, 0.7) !important;
      transform: translateY(-1px);
    }
  }
`;
